
<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="8" lg="6" xl="4">
      <v-card class="elevation-12 pa-9">
        <v-row class="mt-1 mb-5" justify="center">
          <v-toolbar-title class="wrap-text">
            PlatJaMからサインアウトしますか？
          </v-toolbar-title>
        </v-row>
        <v-row class="text-center">
          <v-col>
            <v-btn @click="logout">
              サインアウト
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="text-center">
          <v-col>
            <v-btn @click="$router.go(-1)">
              元の画面に戻る
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import repository from '@/store/repository'

export default {
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      showPassword: false
    }
  },
  methods: {
    logout () {
      this.$cognito.logout()

      repository.clearAll()
      this.$store.commit('setUser', null)
      this.$store.commit('setIdToken', null)
      this.$store.commit('setAccessToken', null)
      this.$store.commit('setUserName', null)
      this.$store.commit('setCurrentUnit', null)
      this.$store.commit('setCurrentLesson', null)
      this.$store.commit('setRegistCourseId', null)
      this.$router.push('/')
    }
  }
}
</script>
